export default {
  install(Vue) {
    Vue.prototype.$fileIcon = function(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      let icon = 'type_unknown.png';
      switch (extension) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          icon = 'type_image.png';
          break;
        case 'avi':
        case 'mp4':
        case 'mov':
        case 'mkv':
          icon = 'type_video.png';
          break;
        case 'wma':
        case 'wav':
        case 'mp3':
        case 'acc':
          icon = 'type_audio.png';
          break;
        case 'txt':
          icon = 'type_txt.png';
          break;
        case 'doc':
        case 'docx':
          icon = 'type_word.png';
          break;
        case 'pdf':
          icon = 'type_pdf.png';
          break;
        case 'rar':
        case 'zip':
        case 'tar':
        case '7z':
          icon = 'type_zip.png';
          break;
        case 'ppt':
        case 'pptx':
          icon = 'type_ppt.png';
          break;
        case 'xls':
        case 'xlsx':
        case 'csv':
          icon = 'type_excel.png';
          break;
        default:
          break;
      }
      return require(`@/assets/${icon}`);
    };

    // 日期格式化方法
    Vue.prototype.$formatDate = function(timestamp, format = 'yyyy-MM-dd HH:mm:ss') {
      const date = new Date(timestamp);
      const map = {
        'yyyy': date.getFullYear(),
        'MM': String(date.getMonth() + 1).padStart(2, '0'),  // 月份从 0 开始
        'dd': String(date.getDate()).padStart(2, '0'),
        'HH': String(date.getHours()).padStart(2, '0'),
        'mm': String(date.getMinutes()).padStart(2, '0'),
        'ss': String(date.getSeconds()).padStart(2, '0')
      };

      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, match => map[match]);
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js